import { createStandardAction, getType, ActionType } from 'typesafe-actions';

import { RootAction } from '../../RootAction';

const CHANGE = 'PeeringWeb/Localization/CHANGE';

export type Language = 'cz' | 'en';

export const languagesArray: Language[] = ['cz', 'en'];

export const changeLanguage = createStandardAction(CHANGE)<Language>();

export type Actions = ActionType<typeof changeLanguage>;

export interface LocalizationState {
  language: Language;
}

const defaultState: LocalizationState = {
  language: 'en',
};

export default (state: LocalizationState = defaultState, action: RootAction) => {
  switch (action.type) {
    case getType(changeLanguage):
      return {
        language: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// /www/client/src/containers/Localization/localizationDuck.ts